/** @typedef {{ id: string, areas: string[] }} GrammarCategoryDef */

/** @type {string[]} Primary buckets shown inline next to level filters. */
export const PRIMARY_GRAMMAR_CATEGORY_IDS = ["noun", "verb", "adjective", "syntax"];

/** @type {GrammarCategoryDef[]} */
export const GRAMMAR_CATEGORIES = [
  { id: "verb", areas: ["verb"] },
  { id: "noun", areas: ["noun", "case", "number"] },
  { id: "pronoun", areas: ["pronoun"] },
  { id: "article", areas: ["article"] },
  { id: "adjective", areas: ["adjective"] },
  { id: "preposition", areas: ["preposition"] },
  { id: "adverb", areas: ["adverb", "particle"] },
  { id: "syntax", areas: ["syntax"] },
  { id: "other", areas: ["lexical-pattern", "style", "other"] },
];

/** @type {Map<string, string>} */
const AREA_TO_CATEGORY = new Map();
for (const cat of GRAMMAR_CATEGORIES) {
  for (const area of cat.areas) {
    AREA_TO_CATEGORY.set(area, cat.id);
  }
}

/**
 * @param {string | null | undefined} area
 * @returns {string | null}
 */
export function categoryForArea(area) {
  const raw = String(area || "").trim().toLowerCase();
  if (!raw) return null;
  return AREA_TO_CATEGORY.get(raw) || "other";
}

/**
 * @param {Iterable<string | null | undefined>} areas
 * @returns {string[]}
 */
export function categoriesForAreas(areas) {
  /** @type {string[]} */
  const out = [];
  const seen = new Set();
  for (const area of areas || []) {
    const id = categoryForArea(area);
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out.sort(
    (a, b) =>
      GRAMMAR_CATEGORIES.findIndex((c) => c.id === a) -
      GRAMMAR_CATEGORIES.findIndex((c) => c.id === b),
  );
}

/**
 * @param {Record<string, string> | null | undefined} labels
 * @param {string} categoryId
 * @returns {string}
 */
export function grammarCategoryLabel(labels, categoryId) {
  const id = String(categoryId || "").trim();
  if (!id) return "";
  const fromMap = labels && typeof labels === "object" ? labels[id] : "";
  if (fromMap) return String(fromMap);
  const fallback = GRAMMAR_CATEGORIES.find((c) => c.id === id);
  return fallback?.id || id;
}
